export function normalizeValue(value: string): string {    
    const newValue = value.toLowerCase().replace(/\s/g, '');
    return removeAccents(newValue);
}

export function removeAccents(value: string): string {
    const valueContaisAccets = value.match(/[áàâãéèêíïóôõöúçñ]/g);

    if (valueContaisAccets) {
        let newValue = value;
        newValue = newValue.replace(/[áàâã]/g, 'a');
        newValue = newValue.replace(/[éèê]/g, 'e');
        newValue = newValue.replace(/[íï]/g, 'i');
        newValue = newValue.replace(/[óôõö]/g, 'o');
        newValue = newValue.replace(/[ç]/g, 'c');
        newValue = newValue.replace(/[ú]/g, 'u');
        newValue = newValue.replace(/[ñ]/g, 'n');
        return newValue;
    }

    return value;
}